import React, { useContext } from "react";
import { Card, Typography } from "@mui/material";
import ButtonInput from "../Button_Components/ButtonInput";
import DataContext from "../../Context/DataContext";
import FormSection from "./FormSection";

function Form() {
  const {
    MandatoryFields,
    EmployeeDetailsFields,
    handleFinalSubmitData,
    CommunicationDetails,
    BankDetails,
    EducationList,
    addNewRow,
    EmployerList,
    enableError,
    submitLoading
  } = useContext( DataContext );

  const sectionRender = [
    {
      id: 1,
      title: "Mandatory Details",
      data: [ { id: 1, array: MandatoryFields } ],
      Component: FormSection,
      multiple: false,
    },
    {
      id: 2,
      title: "Employee Details",
      data: [ { id: 1, array: EmployeeDetailsFields } ],
      Component: FormSection,
      multiple: false,
    },
    {
      id: 3,
      title: "Communication Details",
      data: [ { id: 1, array: CommunicationDetails } ],
      Component: FormSection,
      multiple: false,
    },
    {
      id: 4,
      title: "Education Details",
      data: EducationList,
      Component: FormSection,
      multiple: true,
      addNewRow: addNewRow,
      
    },
    {
      id: 5,
      title: "Previous Employer Details",
      data: EmployerList,
      Component: FormSection,
      multiple: true,
      addNewRow: addNewRow,
      expand: true
    },
    {
      id: 6,
      title: "Bank Details",
      data: [ { id: 1, array: BankDetails } ],
      Component: FormSection,
      multiple: false,
      expand: true
    },
  ];

  return (
    <>
      <Card
        sx={ {
          margin: "24px auto",
          padding: "12px",
          border: "1px solid rgb(216, 216, 216)",
          backgroundColor: "rgb(252, 252, 252)",
          textAlign: "end",
          boxShadow: "1px 1px 10px rgb(202, 202, 202)",
        } }
      >
        <div
          style={ {
            textAlign: "start",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          } }
        >
          <Typography variant="h6" color="#272727">
            Fill The Details
          </Typography>
          {/* <ButtonInput title="Get Details" onClick={handleGetDetails} /> */ }
        </div>
        <hr style={ { backgroundColor: "#e2e2e2 ", margin: "12px 0" } } />

        { sectionRender?.map(
          ( { id, title, data, multiple, addNewRow, Component, expand } ) => {
            return (
              <Component
                key={ id }
                title={ title }
                data={ data }
                multiple={ multiple }
                addNewRow={ addNewRow }
                expand={ expand }
              />
            );
          }
        ) }

        <div style={ { display: "flex", justifyContent: "end" } }>
          {/* <ButtonInput title="Cancel" type="outlined" /> */ }
          <ButtonInput
            title="Save"
            type="contained"
            loading={ submitLoading }
            onClick={ handleFinalSubmitData }
            disabled={ enableError }
          />
        </div>
      </Card>
    </>
  );
}

export default Form;
